define([
	"dojo/_base/declare",
	"csi/heading/TimeDateTime",
	"csi/state/rootStore",
	"csi/types",
], function(declare, TimeDateTime, {sessionStore}, types) {

	return declare(TimeDateTime, {
		/**
		 * @override
		 * Render full date and time when printing
		 */
		formatValue: function(value, fmt) {
			return types.formatTime(value, sessionStore.print ? types.FORMAT_DATETIME : fmt);
		}
	});
});